"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
var _default = {
  name: 'App',
  provide: function provide() {
    return {
      reload: this.reload
    };
  },
  data: function data() {
    return {
      showPage: true
    };
  },
  methods: {
    reload: function reload() {
      var _this = this;

      this.showPage = false;
      this.$nextTick(function () {
        _this.showPage = true;
      });
    }
  }
};
exports.default = _default;